export default {
    styleOverrides: {
        root: {
            width: "100%",
            borderRadius: "6px 6px 0 0",
            overflowX: 'scroll',
        }
    }
}